import "./commission.css";
import CommissionList from "./components/cms-list";
import ButtonRow from "./components/button-row";
import React, { useEffect, useState } from "react";
import "./home.css";
import { Helmet } from "react-helmet";

function Commission() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [listVisible, setListVisible] = useState(false);

  useEffect(() => {
    const imageTimer = setTimeout(() => setImageLoaded(true), 200);
    const listTimer = setTimeout(() => setListVisible(true), 250);
    return () => {
      clearTimeout(imageTimer);
      clearTimeout(listTimer);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>✧･ﾟcommission･ﾟ✧</title>
      </Helmet>
      <div className="image-section">
        <img
          className={`home-image ${imageLoaded ? "fade-in" : ""}`}
          src="https://img5.pic.in.th/file/secure-sv1/-1058_20230623151426-1.png"
          alt="ไม่มีชื่อ 1058 20230623151426 (1)"
        />
        <h1 className="home-title">M I L D M I S A K I</h1>
      </div>
      <ButtonRow />
      <div className={`fade-up ${listVisible ? "show" : ""}`}>
        <h1 className="header-semireal-gl">✧･ﾟCOMMISSION･ﾟ✧</h1>
        <CommissionList />
      </div>
    </div>
  );
}

export default Commission;
